import { render, staticRenderFns } from "./SoCourse.vue?vue&type=template&id=6bd04780"
import script from "./SoCourse.vue?vue&type=script&lang=js"
export * from "./SoCourse.vue?vue&type=script&lang=js"
import style0 from "./SoCourse.vue?vue&type=style&index=0&id=6bd04780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports